import React, { useEffect } from "react";
import "./mission.css";
import Aos from "aos";
import "aos/dist/aos.css";

export default function HomeMission() {
    useEffect(() => {
      Aos.init({ duration: 2000 });
    }, []);
  
    return (
      <div className="mission-container">
        <div className="mission-wrapper"
          data-aos="fade-right"
          data-aos-duration="900"
        >
          <div className="mission-title">
            Our <small>Vision</small>
          </div>
          <div className="mission-description">
            <p>
            To be the most trusted and innovative agency for work visa and HR services in 
            Dubai, known for delivering unparalleled value and setting the benchmark for 
            service quality in the industry.
            </p>
          </div>
        </div>
  
        <div className="mission-wrapper border-radius"
          data-aos="fade-left"
          data-aos-duration="900"
        >
          <div className="mission-description text-right">
            <p>
            To empower individuals and businesses by simplifying the 
            process of obtaining work visas in Dubai and providing comprehensive 
            HR solutions that enable our clients to thrive in a dynamic global environment. 
            </p>
          </div>
          <div className="mission-title">
            Our <small>Mission</small>
          </div>
        </div>
      </div>
    );
  }


 


  